/* One cart mutation at a time. Coalesce quantity taps without dropping intent. */
(function (scope) {
  'use strict';
  class CartQueue {
    constructor({ perform, onChange = () => {}, onError = () => {}, debounce = 160 }) {
      this.perform = perform;
      this.onChange = onChange;
      this.onError = onError;
      this.debounce = debounce;
      this.pending = [];
      this.active = null;
      this.timer = null;
      this.waiters = [];
      this.sequence = 0;
    }
    get busy() { return !!this.active || this.pending.length > 0; }
    get operations() { return [this.active, ...this.pending].filter(task => task && !task.committed); }
    change(identity, quantity) {
      let existing;
      // An add is an ordering barrier: never merge quantities across an add.
      for (let i = this.pending.length - 1; i >= 0; i--) {
        if (this.pending[i].kind === 'add') break;
        if (this.pending[i].identity === identity) { existing = this.pending[i]; break; }
      }
      if (existing) existing.quantity = quantity;
      else this.pending.push({ kind: 'change', identity, quantity, id: ++this.sequence });
      this.onChange();
      this.schedule(this.debounce);
    }
    add(payload) {
      const task = { kind: 'add', payload, id: ++this.sequence };
      this.pending.push(task);
      this.onChange();
      this.schedule(0);
      return task;
    }
    schedule(delay) {
      if (this.active) return;
      clearTimeout(this.timer);
      if (!delay) this.run();
      else this.timer = setTimeout(() => this.run(), delay);
    }
    async run() {
      if (this.active) return;
      clearTimeout(this.timer);
      this.timer = null;
      while (this.pending.length) {
        const task = this.pending.shift();
        this.active = task;
        this.onChange();
        try {
          await this.perform(task);
        } catch (error) {
          task.committed = true;
          if (task.kind === 'change') {
            this.pending = this.pending.filter(next => next.kind !== 'change' || next.identity !== task.identity);
          }
          try { await this.onError(error, task); } catch { /* The UI keeps its recovery link. */ }
        } finally {
          this.active = null;
          this.onChange();
        }
      }
      this.waiters.splice(0).forEach(resolve => resolve());
    }
    idle() {
      return this.busy ? new Promise(resolve => this.waiters.push(resolve)) : Promise.resolve();
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = CartQueue;
  else scope.MimiCartQueue = CartQueue;
})(typeof window !== 'undefined' ? window : this);
